export const home = {
    hero: {
        badge: 'Líder em Tecnologia de Drones',
        title: {
            line1: 'Soluções em Drones',
            line2: 'para Agricultura',
        },
        description: 'Oferecemos drones profissionais de alta qualidade e assistência técnica especializada em drones agrícolas. Tecnologia de ponta para maximizar sua produtividade.',
        features: {
            feature1: 'Drones profissionais certificados',
            feature2: 'Assistência técnica especializada',
            feature3: 'Suporte técnico completo',
        },
        cta: {
            primary: 'Ver Catálogo',
            secondary: 'Fale Conosco',
        },
        image: {
            alt: 'Drone profissional para agricultura',
        },
    },
    footer: {
        company: {
            name: 'Fronteira Sul Drones',
            description: 'Especialistas em drones profissionais e assistência técnica para drones agrícolas. Oferecemos tecnologia de ponta, manutenção especializada e soluções personalizadas para maximizar a produtividade do seu negócio.',
        },
        badges: {
            experience: 'Anos de Experiência',
            quality: 'Qualidade Garantida',
        },
        sections: {
            quickLinks: 'Links Rápidos',
            contact: 'Contato',
        },
        links: {
            home: 'Início',
            newDrones: 'Drones Novos',
            usedDrones: 'Drones Usados',
            services: 'Serviços',
            about: 'Sobre',
            contact: 'Contato',
        },
        contact: {
            hours: {
                weekdays: 'Segunda a Sexta: {{start}} às {{end}}',
                saturday: 'Sábado: {{start}} às {{end}}',
            },
        },
        copyright: '© {{year}} Fronteira Sul Drones. Todos os direitos reservados.',
        madeBy: {
            label: 'Feito pela',
            ariaLabel: 'Feito pela AttoDev',
        },
    },
    about: {
        badge: 'Sobre Nós',
        title: {
            part1: 'Conheça a',
            part2: 'Fronteira Sul Drones',
        },
        description: {
            paragraph1: 'A Fronteira Sul Drones é uma empresa especializada em soluções tecnológicas para agricultura, oferecendo drones profissionais de alta qualidade e assistência técnica especializada em drones agrícolas.',
            paragraph2: 'Com anos de experiência em drones de pulverização agrícola, nossa missão é proporcionar tecnologia de ponta que maximize a produtividade e eficiência dos nossos clientes, sempre priorizando qualidade, segurança e inovação.',
            paragraph3: 'Trabalhamos com equipamentos certificados e uma equipe altamente qualificada, garantindo resultados excepcionais em cada projeto.',
        },
        values: {
            title: 'Nossos Valores',
            quality: 'Qualidade',
            innovation: 'Inovação',
            reliability: 'Confiabilidade',
            excellence: 'Excelência',
        },
    },
    newDrones: {
        badge: 'Linha Profissional',
        title: 'Drones Novos',
        subtitle: 'Tecnologia de ponta para suas necessidades',
        viewCatalog: 'Ver Catálogo Completo',
        features: 'Características',
        inStock: 'Em Estoque',
        outOfStock: 'Fora de Estoque',
        noProducts: 'No momento não temos drones novos disponíveis. Volte em breve ou entre em contato.',
    },
    usedDrones: {
        badge: 'Oportunidade Verificada',
        title: 'Drones Usados',
        subtitle: 'Qualidade garantida com melhor custo-benefício',
        viewCatalog: 'Ver Catálogo Completo',
        condition: 'Condição',
        features: 'Características',
        inStock: 'Em Estoque',
        outOfStock: 'Fora de Estoque',
        noProducts: 'No momento não temos drones usados disponíveis. Confira nosso catálogo de novos.',
    },
    buffalo: {
        badge: 'Motores e Acoplados',
        title: 'Linha Buffalo',
        subtitle: 'Excelência em motores e soluções para todo o Brasil',
        viewCatalog: 'Ver Catálogo da Linha Buffalo',
        noProducts: 'Em breve teremos motores e acoplados da Linha Buffalo disponíveis no catálogo.',
    },
    powerCitros: {
        badge: 'Ultra Limpador Cítrico',
        title: 'Power Citros',
        subtitle: 'O único produto que você precisa para limpar tudo — drones, veículos, equipamentos agrícolas e muito mais. Fórmula biodegradável de alto desempenho.',
        viewCatalog: 'Ver Produtos Power Citros',
        noProducts: 'Em breve teremos os produtos da linha Power Citros disponíveis no catálogo.',
    },
    parts: {
        badge: 'Peças Originais',
        title: 'Peças e Acessórios',
        subtitle: 'Encontre as melhores peças originais e acessórios para seu equipamento',
        viewCatalog: 'Ver Catálogo de Peças',
        noProducts: 'Em breve teremos peças disponíveis em nosso catálogo online.',
    },
    spraying: {
        badge: 'Serviços Especializados',
        title: {
            part1: 'Assistência Técnica e Manutenção',
            part2: 'em Drones Agrícolas',
        },
        subtitle: 'Serviços especializados de assistência técnica e manutenção para drones agrícolas. Equipe qualificada e peças originais para garantir o máximo desempenho dos seus equipamentos.',
        description: {
            paragraph1: 'Oferecemos assistência técnica completa e serviços de manutenção preventiva e corretiva para drones agrícolas, com foco em manter seus equipamentos sempre em perfeito estado de funcionamento.',
            paragraph2: 'Nossa equipe é composta por técnicos altamente qualificados, com vasta experiência em drones agrícolas e certificações para trabalhar com equipamentos de última geração.',
            paragraph3: 'Trabalhamos com peças originais, realizamos diagnósticos precisos e oferecemos suporte técnico completo para maximizar a vida útil e o desempenho dos seus drones.',
        },
        benefits: {
            title: 'Benefícios',
            precision: 'Diagnóstico Preciso',
            efficiency: 'Manutenção Rápida',
            safety: 'Peças Originais',
            technology: 'Técnicos Certificados',
        },
        services: {
            title: 'Nossos Serviços',
            mapping: 'Manutenção preventiva e inspeções periódicas completas',
            calibration: 'Calibração e configuração de sistemas de pulverização e sensores',
            application: 'Reparo e substituição de peças com componentes originais',
            support: 'Suporte técnico especializado e treinamento de operadores',
        },
        equipment: {
            title: 'Equipamentos',
            description: 'Utilizamos drones XAG P100 Pro com tecnologia RTK, garantindo precisão e eficiência em todas as operações.',
            certified: 'Certificado MAPA',
        },
        cta: {
            button: 'Solicitar Orçamento',
            description: 'Entre em contato e solicite um orçamento personalizado para sua propriedade',
        },
    },
    metrics: {
        title: 'Nossos Números',
        subtitle: 'Resultados que comprovam nossa experiência e compromisso com a excelência no agronegócio',
        hectares: 'Hectares Pulverizados',
        clients: 'Clientes Atendidos',
        experience: 'Anos de Experiência',
        drones: 'Drones Operacionais',
        economy: 'Economia de Defensivos',
        precision: 'Precisão de Aplicação',
        suffix: {
            hectares: '+ ha',
            clients: '+',
            years: ' anos',
            drones: ' unidades',
            economy: '%',
            precision: '%',
        },
    },
    contact: {
        badge: 'Entre em Contato',
        title: 'Fale Conosco',
        subtitle: 'Estamos prontos para ajudar você a encontrar a melhor solução em drones',
        whatsapp: {
            title: 'WhatsApp',
            description: 'Fale conosco diretamente pelo WhatsApp',
            button: 'Conversar no WhatsApp',
            cta: 'Resposta rápida e atendimento personalizado',
        },
        other: {
            title: 'Outros Meios de Contato',
            email: {
                label: 'E-mail',
            },
            phone: {
                label: 'Telefone',
            },
            address: {
                label: 'Endereço',
            },
            hours: {
                label: 'Horário de Atendimento',
            },
        },
    },
    productCard: {
        featured: 'Destaque',
        buy: 'Comprar',
        types: {
            new: 'Edição Pro',
            used: 'Qualidade Verificada',
            buffalo: 'Linha Buffalo',
            'power-citros': 'Power Citros',
            parts: 'Peça Original',
        },
    },
};
//# sourceMappingURL=home.js.map